import '../index.css';
var styles = {
  "container": "bp_combobox_module_container--bd962",
  "disabled": "bp_combobox_module_disabled--bd962",
  "label": "bp_combobox_module_label--bd962",
  "hiddenLabel": "bp_combobox_module_hiddenLabel--bd962",
  "comboboxContainer": "bp_combobox_module_comboboxContainer--bd962",
  "withComboboxButtons": "bp_combobox_module_withComboboxButtons--bd962",
  "error": "bp_combobox_module_error--bd962",
  "textInputWrapper": "bp_combobox_module_textInputWrapper--bd962",
  "textInput": "bp_combobox_module_textInput--bd962",
  "errorIcon": "bp_combobox_module_errorIcon--bd962",
  "comboboxButtons": "bp_combobox_module_comboboxButtons--bd962",
  "withChips": "bp_combobox_module_withChips--bd962",
  "inlineError": "bp_combobox_module_inlineError--bd962",
  "popover": "bp_combobox_module_popover--bd962",
  "option": "bp_combobox_module_option--bd962",
  "indicator": "bp_combobox_module_indicator--bd962",
  "indicatorIcon": "bp_combobox_module_indicatorIcon--bd962",
  "optionWithIndicator": "bp_combobox_module_optionWithIndicator--bd962",
  "loadingIndicator": "bp_combobox_module_loadingIndicator--bd962",
  "noResultOption": "bp_combobox_module_noResultOption--bd962"
};
export { styles as default };